export default {
    common: {

        en: "ENG",
        zh: "CHI",

        appName: '地理位置標記工具',
        appNameWebTitle: '地理位置標記工具',
        supportCRSMessage: '***只支援 WGS84 及 HK80***',

        marker: "地理標記",

        helpTitleTips: "開始導覽",

        //map control
        zoomIn: "放大",
        zoomOut: "縮小",
        viewPoint: "預設範圍",

        //tour
        title_tour: "開始網頁遊覽",

        //Edit & Remove Markers Icon
        editMarkerTools: {
            editMarkersConfirmMessage: "確認修改記錄?",
            removeMarkersConfirmMessage: "確認刪除記錄?",
        },

        //layers
        searchResult: "搜尋結果",
        searchResultBefore: "共",
        searchResultAfter: "項結果",
        identify: "地點辨認",
        layers: "圖層",
        topoLayer: "地形圖",
        orthoLayer: "正射影像地圖",
        tableLayer: "表格圖層",
        lotLayer: "地段圖層",
        buildingLayer: "建築圖層",

        //identify
        coordinates: "坐標",
        lotName: "地段名稱",
        prn: "物業參考編號 (PRN)",
        hk80x: "坐標東(米)",
        hk80y: "坐標北(米)",
        errorIdentifyMessage: "連接失敗, 請稍後再試。",

        //Add Layer
        reviewGeoData: "瀏覽香港地理數據站",
        addLayer: "新增圖層(網絡)",
        removeLayers: "清除全部圖層",
        manageLayers: "管理圖層",
        url: '連結',
        layerName: '圖層名稱',
        layerType: '圖層類型',
        layerParams: '參數 (可空白)',
        layerParamsMessage: '例子: key=abcd1234&name=1234',
        layerLayers: '顯示圖層',
        layerLayersMessage: '例子: Building,Site,SubSite',
        layerWhere: '條件 (可空白) (只支援 ArcGIS Feature Layer)',
        layerWhereMessage: "例子: City = 'Hong Kong' AND Place = 'Central' ",
        required: '要求輸入',
        newColumnNameRequired: "請輸入欄目名稱",
        style: '設計',
        layerColor: '圖層顏色',
        layerNameExisting: '此圖層名稱已存在',
        confirmToDeleteLayerMessage: "<br/>確認刪除此圖層?",
        confirmDeleteAllLayersMessage: "<br/>確認刪除全部圖層?",
        connectLayerNetworkMessage: "提取網絡資源失敗",
        connectLayerFailedMessage: "讀取資料錯誤",
        zoomInToEnableFeatureMessage: "可能需要放大地圖以觀看此圖層",
        identifyLocationFailedMessage: "讀取地點資訊失敗, 請稍後再試",

        copyrightString: "©地圖版權屬香港特別行政區政府",

        ok: "確定",
        cancel: "取消",
        close: "關閉",
        clear: "清除",

        latitude: '緯度',
        longitude: '經度',
        // latitude_northing: '緯度 / 坐標北',
        // longitude_easting: '經度 / 坐標東',
        northing: '坐標北',
        easting: '坐標東',

        importDialogMessage: "您想匯入上次的數據嗎?",

        //Menu
        import: "匯入數據",
        export: "下載地理數據",
        autoSave: "暫存於瀏覽器(已啟用)",
        noAutoSave: "暫存於瀏覽器(已關閉)",
        lastSavedMessage: "最後儲存時間:",

        //Search Bar
        searchPlace: "搜尋大廈、設施、地址等",
        errorSearchPlaceMessage: "連接失敗, 請稍後再試。",

        //Search result
        recordnotfound: "找不到記錄",
        norecord: "沒有記錄",

        //Matching Dialog
        matchDialog: {
            matchAddNewLocation: "加入新數據",
            matchCopyToSelectedItem: "複製到已選表格記錄(號碼)",
            matchCopyToCoordinate: "複製坐標資訊",
            matchAdvancedOption: "進階選項",
            matchFields: "複製地圖資訊",
            matchFieldsTitle: "對應欄目",
            createColumn: "新增欄目",
        },

        //input dialog
        confirm: "確認",
        attention: "注意",
        confirmInputMessage: "如果沒有設定 \"地址\" 及 \"名稱\" 表格類型 於 表格欄目, 系統將會使用預設欄目來代替",

        //loading dialog
        loadingDialog: {
            title: "自動標記位置 (根據匯入的位置資訊)",
            totalCases: "全部項目",
            successMatches: "成功配對",
            abort: "中止",
            runInBackground: "背景執行",
            completedMatchMessage: "已完成配對坐標",
            reachMaxMatchItems: "此功能只適用少於{number}行紀錄的檔案",
            connectFailedTasksMessage: "連接網絡查詢失敗",
            latitude: "緯度<br/>(十進制度小數)",
            longitude: "經度<br/>(十進制度小數)"
        },

        spaceUsed: '已使用儲存空間',

        number: "數字",
        date: "日期 (年-月-日)",
        // multiText: "多行文字",
        multiText: "文字",
        singleText: "單行文字",
        address_zh: "地址(中文)",
        address_en: "地址(英文)",
        name_zh: "名稱(中文)",
        name_en: "名稱(英文)",

        //Guided Tour
        guidedTour: "網站導覽",

        //Import Dialog
        importDialog: {
            file: "檔案",
            format: "格式",
            foundInfo: "提示",
            foundProblem: "發現問題",
            option: "標記位置選項",
            crsWGS1984Display: "WGS84<br/>(緯度，經度)",
            crsHK1980Display: "HK1980方格網<br/>(坐標北，坐標東)",
            inputOption: "匯入形式",
            batchLocationSearch: "自動",
            batchLocationSearchManual: "手動",
            batchLocationSearchManualStart: "",
            batchLocationSearchManualCoord: "使用匯入的坐標",
            batchLocationSearchManualAddress: "使用匯入的位置資訊",
            autoMatchField: '選擇相應欄目',
            Append: "追加",
            ReplaceAll: "取代全部",
            browser: "瀏覽",
            selectedFile: "已選檔案",
            fileChooseOrDropMessage: "選擇匯入的檔案或將其拖曳到此處 ...",
            fileDropFileMessage: "將檔案拖曳到此處 ...",
            // fileEmptyFileMessage: "沒有檔案",
            // missSelectedLatitudeLongitude: '請選擇經度和緯度',
            message: '訊息',
            coordinateReferenceSystem: '坐標系統',
            nonPointData: "只支援匯入以 \"點\" 為標記的空間數據",
            systemholdcolumnname: '欄目名稱已被系統使用, 請修改檔案內欄目名稱',
            fileAndFormatIncompatible: '檔案與格式不相容',
            convertDateTypeFailed: '嘗試轉換為"日期"類型失敗, 請修改檔案內的欄目資料',
            convertNumberTypeFailed: '嘗試轉換為"數字"類型失敗, 請修改檔案內的欄目資料',
            notAtHKMessage: "部份數據位置並不在本地圖支援範圍內, 您可以 修改檔案 或 繼續輸入",
            reminder: "注意",
            exportAutoMatchDownloadMessage: "-	偵測到自動標記的數據。<u>下載前請確定標記無誤。</u>",
            exportNotIncludeNonMarkerMessage: "- 偵測到未有標記的數據。<u>請注意輸出檔案只會包含已加入地理標記的數據。</u>",
            exporHasIEGMLNotAvailableFieldsMessage: "- 欄目名稱不被支援(包括中文), 請修改以下欄目名稱:",
            exportContainEmptyFieldsNameForGML: "- GML 格式不支援空白欄目標題。",
            exportFieldsNameStartWithLetterForGML: "- 欄目名稱必須以英文字母或底線開頭。",
            exportOverStringSizeForGML: "- 每個輸入儲存格最多可包含 5,000 個字符。", 
            confirmNotMatchCorrect: "使用<u>位置資訊</u>作自動標記<b>可能不準確</b>，請小心檢查標記結果。",
            manualGeotagMessage: "匯入數據後, 可透過地圖 或 搜尋功能來標記位置。",
            exportHasDuplicatedColumnNameForCSDI: "欄目名稱重複(不區分大小寫)，",
            exportHasInvalidNameForCSDI: "欄目名稱含有無效字符，",
            exportHasInvalidLayerNameForCSDI: "圖層名稱含有無效字符，",
            exportHasLongNameForCSDI: "欄目名稱最多可包含 64 個字符，",
            exportHasLongLayerNameForCSDI: "圖層名稱最多可包含 160 個字符",
            exportHasErrorAddon: "請於[欄目設定]修正以下問題。",
            exportErrorColumnNo: "欄目號.",
            exportErrorLayerName: "圖層名稱: ",
            exportGMLForCSDI: "空間數據共享平台(CSDI)格式",
        },

        //Table
        tableOf: "的",
        indexFieldTitle: "坐標",
        column: "欄目",
        table: "於表格新增／管理數據",
        search: "搜尋",
        perPage: "每頁",
        typeToSearch: "篩選記錄",
        manageColumns: "圖層及欄目設定",
        manageColumnsShortForm: "欄目",
        addBlankRecord: "新增記錄",
        deletAllRecord: "刪除全部記錄",
        selectedTableId: "已選取記錄(號碼)",
        removeAllColumns: "刪除全部表格欄目",
        extent: "範圍",
        index: "索引",
        allRecord: "全部記錄",
        allRecordAndCols: "全部欄目及記錄",
        confirmToDeleteAllRecordMessage: "確認刪除全部記錄?",
        confirmToDeleteAllRecordAndColsMessage: "確認刪除全部欄目及記錄?",
        confirmToDeleteColAndRelatedRecordMessage: "確認刪除此欄目及相關記錄?",
        confirmToDeleteRecordMessage: "確認刪除記錄?",
        confirmToDeleteAllColumns: "確認刪除全部欄目?",
        sortableList: "自訂欄目",
        newColumnName: "新欄目名稱",
        add: "新增",
        removeData: "記錄",
        colNameIsExistingMessage: "欄目名稱重複",
        colNameIsExistingSystemUsedMessage: "此欄目名稱已被系統使用",
        nocolumnMessage: "沒有欄目",
        confirmToChangeTypeMessage: '確認更改此欄目類型?',
        convertDataFailedMessage: '更改欄目類型失敗. 請檢查相關數據(Index): <br/><br/>',
        clearConvertDataFailedMessage: '<br/><br/> 或您可按 "清理", 將相關欄目資料清除.',
        clearConvertDataFailed: '清理',
        addMarkerByClickMapMessage: '請點擊地圖來新增標記',
        addBuildingLayerByClickMapMessage: '請點擊地圖來附加建築圖層',
        addSubLayerByClickMapMessage: '請選取圖層及點擊地圖, 來新增相關圖層',
        empty: "空白",
        tableColumnDuplicated: "欄目名稱重複",
        tableColumnXmlStandard: "欄目名稱含有無效字符",
        tableColumnLayerName: "定義圖層名稱",

        //Filter
        //PLEASE ALSO ADD TO GLOBAL.JS
        FILTER_COMMEND: {
            NONGEOTAGGED: "只顯示沒有位置標記的結果",
            GEOTAGGED: "只顯示已位置標記的結果",
            AUTOMATCHED: "只顯示自動標記結果 (使用匯入的位置資訊)",
            AUTOMATCHEDXY: "只顯示自動標記結果 (使用匯入的坐標)",
        },

        //Print
        printTitle: "列印地圖",
        printPortrait: "直向",
        printLandscape: "橫向",
        printAuto: "自動",
        printCustom: "自訂",
        printCustomMessage: "請在地圖上選取範圍以列印該位置",

        //Draw
        radius: '半徑',
        finish: '完成',
        finishTitle: '完成繪製',
        undo: '刪除最後一點',
        undoTitle: '刪除最後繪製的點',
        actions: '完成',
        actionsTitle: '完成繪圖',
        save: '保存',
        saveTitle: '保存更改',
        // cancel: '取消',
        cancelTitle: '取消修改，放棄全部更改',
        clearAll: '全部清除',
        clearAllTitle: '清除全部圖層',

        drawAPolyLine: '繪畫多邊形線',
        drawPolylineTooltipStart: '單擊以開始畫線。',
        drawPolylineTooltipCont: '單擊以繼續畫線。',
        drawPolylineTooltipEnd: '單擊最後一點以完成終點線。',

        drawAPolygon: '繪畫多邊形',
        drawPolygonTooltipStart: '單擊以開始繪製形狀。',
        drawPolygonTooltipCont: '單擊以繼續繪製形狀。',
        drawPolygonTooltipEnd: '單擊第一個點以關閉此形狀。',

        drawARectangle: '繪畫矩形',
        drawRectangleTooltipStart: '單擊並拖動以繪製矩形。',

        drawACircle: '繪畫圓',
        drawCircleTooltipStart: '單擊並拖動以繪製圓圈。',

        drawAMarker: '繪畫標記',
        drawMarkerTooltipStart: '點擊地圖放置標記。',

        drawSimpleShapeTooltipEnd: '釋放鼠標以完成繪圖。',

        drawEditButton: "修改標記",
        drawEditDisabled: "沒有要修改的標記",
        drawRemove: "刪除標記",
        drawRemoveDisabled: "沒有要刪除的標記",

        drawHandlerEditTooltip: "拖拉標記來修改。",
        drawHandlerEditTooltipSubtext: "點擊\"取消\"來取消更改。",
        drawHandlerRemoveTooltip: "點擊標記來刪除記錄。",

        //locate
        locateTitle: '顯示您的位置',

        //button title
        title_showLeftBar: "顯示搜尋結果",
        title_leftBarSliderDrag: "拖拉以改變左側欄寬度",
        title_tableSliderDrag: "拖拉以改變表格高度",
        title_import: "數據導入表格",
        title_export: "表格導出數據",
        title_save: "開啟/關閉自動保存功能",
        title_table: "開啟表格",
        title_language: "切換語言",
        title_searchBar: "輸入關鍵字或地址以搜尋位置",
        title_addLayer: "從網絡資源添加圖層",
        title_removeLayers: "刪除全部圖層",
        title_tabsLayers: "圖層設置",
        title_tabsSearchResult: "已搜索地點結果",
        title_tabsIdentify: "已辨認地點結果",
        title_tabsExtent: "縮放到全部搜尋記錄",
        title_tabsTrash: "清除結果",
        title_closeLeftBar: "隱藏搜尋結果",
        title_onOffLayer: "開啟/關閉圖層",
        title_editLayer: "修改圖層",
        title_switchLayerUp: "排列向上",
        title_switchLayerDown: "排列向下",
        title_removeLayer: "刪除圖層",
        title_close: "關閉",
        title_tableClose: "隱藏",
        title_openLeftBarWithLayer: "開啟左側欄(圖層)",
        title_zoomTo: "縮放至",
        title_addData: "新增記錄到表格上",
        title_copyData: "複製至表格上已選取的記錄",
        title_filteSearchrBar: "輸入關鍵字以篩選表格記錄",
        title_tableExtent: "縮放到全部記錄",
        title_tableManageColumns: "管理表格欄目",
        title_addBlankRecordAtTable: "在表格內加入新記錄",
        title_tableRemoveAllRecord: "刪除全部表格記錄",
        title_tableSelectedTableId: "已選表格記錄號碼",
        title_tableRemoveRecord: "刪除記錄",
        title_tableAddLayer: "附加建築物圖層",
        title_tableRemoveLayer: "刪除建築物圖層",
        title_tableItemInputSearchButton: "快速搜尋",

        title_manageColumnsDeleteAll: "刪除全部欄目及其記錄",
        title_manageColumnsRemoveColumn: "刪除欄目",
        title_manageColumnsType: "欄目類型",
        title_manageColumnsName: "欄目名稱",

        title_addMarker: "在地圖上標記位置",

        content_about: {
            title: "關於 - 標題",
            about: "關於",
            main: "關於 - 內容",
            img: "圖片",
        },

        welcomeAndAbout: {
            title: "歡迎使用地理位置標記工具 (v1.1)",
            content: "地理位置標記工具能把非空間數據 (例如人口統計數據) 轉換成空間數據，並能顯示在地圖上和用於開發地理空間應用程式。本工具主要支持以下功能：",
            content_pointOne: "•    匯入文本數據以便標記位置",
            content_pointTwo: "•    透過地圖加入位置標記",
            content_pointThree: "•  下載已標記位置的數據",
            content_pointFour: "如你在使用「地理位置標記工具」時需要協助，歡迎電郵至 <a href='mailto:sdms_enquiry@landsd.gov.hk'>sdms_enquiry@landsd.gov.hk</a>。",

            next: "下一步",
            prev: "上一步",
            close: "關閉",
            done: "完成",

            mapTitle: "透過地圖標記位置",
            mapDescription: "在地圖上點擊合適的位置。",
            saveTitle: "暫存數據於瀏覽器",
            saveDescription: "點擊按鈕以啟用暫存/停用暫存。",
            importTitle: "匯入數據",
            importDescription: "開始標記位置前，可先從檔案匯入數據。支持的檔案格式: <br/> <b>•  GeoJSON</b>; <br/> <b>•  CSV</b>; <br/> <b>•  KML</b>; <br/> <b>•  GML</b>",
            locationSearchTitle: "透過位置搜尋標記位置",
            locationSearchDescription: "輸入地點的關鍵字或地址。",
            switchMapTitle: "變更地圖主題",
            switchMapDescription: "可選擇地形圖或影像地圖。",
            editOrDeleteGeoTaggedDataTitle: "在地圖上編輯/刪除已標記的數據",
            editOrDeleteGeoTaggedDataDescription: "",
            manageDataInTableTitle: "管理表格內的數據",
            manageDataInTableDescription: "點擊按鈕以開啟表格。用戶可以在此新增、編輯和刪除表格內的數據。",
            downloadTitle: "下載地理數據",
            downloadDescription: "用戶可匯出所有已標記的數據至不同格式的檔案: <br/> <b>•  GeoJSON</b>; <br/> <b>• CSV</b>; <br/> <b>•  KML</b>; <br/> <b>•  GML</b>",

            setDefaultExtentTitle: "縮放至預設範圍",
            // setDefaultExtentDescription: "設定當前地圖範圍至預設範圍"
            setDefaultExtentDescription: ""
        },

        aboutDialog: {
            title: "關於",
            subtitle: "歡迎使用地理位置標記工具 (v1.1)",
            content: "地理位置標記工具能把非空間數據 (例如人口統計數據) 轉換成空間數據，使其能夠顯示在地圖和用於開發地理空間應用程式。本工具主要支持以下功能：",
            content_pointOne: "•    匯入文本數據以便標記位置",
            content_pointTwo: "•    透過地圖加入位置標記",
            content_pointThree: "•  下載已標記位置的數據",
            content_pointFour: "如你在使用「地理位置標記工具」時需要協助，歡迎電郵至 <a href='mailto:sdms_enquiry@landsd.gov.hk'>sdms_enquiry@landsd.gov.hk</a>。",
            title_termsAndConditions: "使用條款及條件及私隱政策",
            // title_privacyPolicy: "私隱政策",
            tab_FAQ: "常見問題",
            title_tab_FAQ: "常見問題",
            tab_intro_video: "影片介紹",
            title_intro_video: "影片介紹",

            title_FAQ1: "<b>開始使用</b>",
            title_FAQ1A: "甚麼是“地理位置標記”?",
            content_FAQ1A: "地理位置標記指將地理位置資訊(如經緯度)加入到非空間數據。",
            title_FAQ1B: "已標記地理位置的數據可以有甚麼應用?",
            content_FAQ1B: "已標記地理位置的數據的應用範圍廣泛，例如用家可以標記他們的公司和餐廳或任何設施，使它們能夠顯示在地圖上。此外，已標記的數據可以應用於空間分析和開發地理空間應用程式等等。",
            title_FAQ1C: "那些類型的數據適合標記地理位置?",
            content_FAQ1C: "任何事物擁有特定的地理位置都適合標記，例如是於香港各區收集的人口統計數據和位於不同地方的零售商鋪的基本資料(可包括商鋪名稱、地址和開放時間)。",

            title_FAQ2: "<b>使用地理位置標記工具</b>",
            title_FAQ2A: "此工具提供甚麼功能?",
            content_FAQ2A: "此工具提供三種主要功能:<br/>1.	匯入文本數據以便標記位置<br/>2.	為數據加入位置標記<br/>3.	下載已標記位置的數據",
            title_FAQ2B: "這工具採用了甚麼地理座標系統?",
            content_FAQ2B: "此工具使用的所有座標皆以1984年世界大地坐標系統 (經緯度) (WGS84) 和 香港1980方格網座標系統 (北距及東距) (HK80) 作為基準。",
            title_FAQ2C: "此工具支援甚麼檔案格式?",
            content_FAQ2C: "此工具支援匯入及下載不同的機讀格式，包括 <b>CSV, GeoJSON, KML and GML</b>。請注意此工具只支援匯入及下載上述格式以 \"點\" 為標記的空間數據。",
            title_FAQ2D: "我該如何匯入自己的數據?",
            content_FAQ2D: "你可以把數據整合及轉換成任一支援的檔案格式(包括CSV、GeoJSON、 KML和GML) 並透過 <img class=\"faq import_data_img\" alt=\"「匯入數據」\" src=\"./img/faq_import_data_button_chi.png\"> 功能(按鈕在工具的右上方)把數據匯入至工具 <b>或</b> 手動輸入數據到工具的表格上。",
            title_FAQ2E: "我可以怎樣新增/修改/刪除表格的欄目?",
            content_FAQ2E: "步驟一:	在工具的左下方，按下<img class=\"faq table_img\" alt=\"「於表格新增/管理數據」\" src=\"./img/faq_table_button_chi.png\"> 以開啟表格。<br/>步驟二:	在表格的左上方，按下 <img class=\"faq col_set_img\" alt=\"「欄目設定」\" src=\"./img/faq_col_set_button_chi.png\">。",
            title_FAQ2F: "我可以怎樣標記數據的地理位置?",
            content_FAQ2F: "<b><u>手動標記位置</u></b> <br/> 1.	透過地圖:<br/>步驟一: 在工具的左下方，按下 <img class=\"faq table_img\" alt=\"「於表格新增/管理數據」\" src=\"./img/faq_table_button_chi.png\"> 以開啟表格。<br/>步驟二: 在相應的數據行列的左側, 按下藍色地圖標記 <img class=\"faq blue_marker_img\" alt=\"藍色地圖標記\" src=\"./img/faq_blue_marker.svg\">。<br/>步驟三: 把地圖標記 <img class=\"faq marker_img\" alt=\"marker\" src=\"./lib/images/marker-icon.png\"> 置於適當的位置。<br/><b>或</b><br/>2.	透過位置搜尋:<br/>步驟一: 透過關鍵字/地址搜尋位置 或 在地圖上左鍵點擊相應位置。<br/>步驟二: 在左側的搜尋結果，按下「複製至表格上已選取的記錄」<img class=\"faq copy_data_img\" alt=\"「複製至表格上已選取的記錄」\" src=\"./img/faq_copy_data_button.png\"> 的按鈕。" +
                "<br/><br/><b><u>自動標記位置 (只適用於CSV檔)</u></b> <br/> 1.	使用匯入的坐標:<br/> 步驟一: 在匯入檔案時，選擇「自動標記位置」<br/> 步驟二: 選擇「使用匯入的坐標」<br/> 步驟三: 選擇相應的坐標系統和坐標欄目<br/><br/> 2.	使用匯入的位置資訊:<br/> 步驟一: 在匯入檔案時，選擇「自動標記位置」<br/> 步驟二: 選擇「使用匯入的位置資訊」<br/> 步驟三: 選擇相應的欄目<br/> (注意: 使用<u>地址</u>作自動標記<b>可能不準確</b>，請小心檢查標記結果)",
            title_FAQ2G: "我可以怎樣修改或刪除已標記的數據的座標?",
            content_FAQ2G: "在工具的左上方，你可以按下 「修改標記」 <img class=\"faq edit_marker_img\" alt=\"「修改標記」\" src=\"./lib/images/draw_edit.png\"> 或 「刪除標記」<img class=\"faq delete_marker_img\" alt=\"「刪除標記」\" src=\"./lib/images/draw_delete.png\"> 去修改或刪除標記的座標。",
            title_FAQ2H: "我可以怎樣下載已標記位置的數據?",
            content_FAQ2H: "在工具右上方按下 <img class=\"faq export_img\" alt=\"「下載地理數據」\" src=\"./img/faq_export_button_chi.png\"> 的按鈕，並選擇合適的輸出格式",
            title_FAQ2I: "我有一個儲存著設施資料的試算表，我可以怎樣匯入這些資料?",
            content_FAQ2I: "我們建議先將資料列表另存成CSV檔案，接著匯入到此工具。請注意首列需要加入數據的標題。<br/><a href=\"./src/CSV sample_CHI.csv\" target=\"_blank\"><u><i>CSV 檔案樣本</i></u></a>",

        },

        CSVAutoMatchTour: {
            title_step1: "步驟一: 用家可使用匯入的位置資訊作自動標記",
            content_step1: "",
            title_step2: "步驟二: 選擇相應的欄目",
            content_step2: "",
            title_step3: "步驟三: 用家可使用篩選功能來檢查自動標記的結果",
            content_step3: "",
        },

        importTour: {
            title_fileSelect: "選擇檔案",
            content_fileSelect: "選擇匯入的檔案",
            title_fileFormat: "檔案格式",
            content_fileFormat: "選擇匯入的檔案格式",
        },

        exportTour: {
            title_fileFormat: "檔案格式",
            content_fileFormat: "選擇匯出的檔案格式",
        },

        LeftBarTour: {
            title_addData: "新增記錄到表格上",
            content_addData: "此位置將用作標記新增的記錄",
            title_copyData: "套用位置及地圖資訊",
            content_copyData: "套用並複製至表格上已選取的記錄",
        },

        TableTour: {
            title_columnSettings: "欄目設定",
            content_columnSettings: "新增，修改或刪除欄目",
            title_addNewRecord: "新增記錄",
            content_addNewRecord: "加入空白記錄",
            title_deleteAllRecord: "刪除全部記錄",
            content_deleteAllRecord: "刪除全部記錄",
            title_disselectRecord: "撤消選定記錄",
            content_disselectRecord: "撤消選定欄目",
        },

        addAndCopyTour: {
            title_add: "套用現有資訊",
            content_add: "套用現有的坐標或地圖資訊到新增的記錄",
            title_copy: "套用現有資訊",
            content_copy: "套用現有的坐標或地圖資訊到已選記錄",
        },

        colSetting: {
            title_remove: "清除所有欄目記錄",
            content_remove: "清除表格上所有欄目記錄",
            title_manage: "管理欄目",
            content_manage: "重新命名，排序，或刪除欄目",
            title_new: "新增欄目",
            content_new: "命名及新增欄目",
            title_add: "新增欄目",
            content_add: "新增欄目",
            title_layerName: "定義圖層名稱",
            content_layerName: "命名圖層名稱用於導出 GeoJSON, KML 及 GML 格式",
        },

        autoSave_titledisclaimer: "注意",
        noAutoSave_titledisclaimer: "注意",
        autoSave_disclaimerContent: "啟用此選項後，編輯將會自動暫存到瀏覽器上的快取。考慮到快取功能於各瀏覽器上有不同的支援，快取亦會被瀏覽器其他功能清除，建議用戶應定期下載數據到本機儲存作備份。",
        noAutoSave_disclaimerContent: "停用此功能後將清除本工具所儲存的快取，所有數據記錄亦會於關閉本網頁後遺失。<b>在停用前，請下載數據到本機儲存作備份。</b>",

        successfully: '成功',
        failed: '失敗',
        insert: "加入",
        edit: "修改",
        record: "記錄",
        copy: "複製",
        remove: "刪除",
        none: '沒有',
        information: "資料",
    },

}